
export default {
    name:'cardModal',
    props:['cart','card'],
    data(){
      return{
        years:[...Array(15).keys()].map(a=>a+(parseInt(new Date().getUTCFullYear())))
      }
    }
}
